import React from 'react';
import { motion } from 'framer-motion';
import Swiperslider from '../Swiperslider/Index';
import ImageTag from '../ImageTag/Index';
import '../Heroslider/index.css';

const Index = ({ Data, ImageWidth, ImageHeight }) => {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.3 }
    }
  };

  const lineVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: 'easeOut' }
    }
  };

  const imageFadeIn = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 1, ease: 'easeOut' }
    }
  };

  const AnimatedText = ({ text }) => {
    const lines = text.split('\n'); 
    return (
      <motion.div
        className="heading text-white greenBorder position-relative d-block px-lg-4 px-3"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {lines.map((line, index) => (
          <motion.div key={index} variants={lineVariants}>
            {line}
          </motion.div>
        ))}
      </motion.div>
    );
  };

  return (
    <>
      <section className='col-12 float-start flex-center overflow-hidden heroSlider position-relative'>
        {Data.length === 0 ? (
          <div className='col-12 float-start Noimage flex-center'>
            <ImageTag ImageAlt={'No Image Found'} />
          </div>
        ) : Data.length === 1 ? (
          <div className={`col-12 float-start slideParent h-100`}>
            <motion.div variants={imageFadeIn} initial="hidden" animate="visible" className='desktop-show h-100'>
              <ImageTag ImagePath={Data[0].imagePath} ImageAlt={Data[0].imageAlt} ImageClass={'w-100 h-100  object-fit'} ImageWidth={ImageWidth} ImageHeight={ImageHeight}/>
            </motion.div>
            <motion.div variants={imageFadeIn} initial="hidden" animate="visible" className='mobile-show h-100'>
              <ImageTag ImagePath={Data[0].mobimgPath || Data[0].imagePath} ImageAlt={Data[0].imageAlt} ImageClass='w-100 h-100 object-fit' ImageHeight={730} ImageWidth={650} />
            </motion.div>
            <div className='col-lg-5 col-md-5 col-8 bannerTextSlide'>
              <AnimatedText text={Data[0].heading.replace(/<\/?[^>]+(>|$)/g, "")} />
            </div>
          </div>
        ) : (
          <Swiperslider spaceBetween={1} slidesPerView={1} navigation={false} pagination={{ clickable: true }} timeDelay={'6000'} effect={'fade'}>
            {Data.map((slide, index) => (
              <div className={`col-12 float-start slideParent h-100`} key={index}>
                <motion.div variants={imageFadeIn} initial="hidden" animate="visible">
                  <ImageTag ImagePath={slide.imagePath} ImageAlt={slide.imageAlt} ImageClass={'w-100 desktop-show'} ImageWidth={ImageWidth} ImageHeight={ImageHeight}/>
                </motion.div>
                <motion.div variants={imageFadeIn} initial="hidden" animate="visible">
                  <ImageTag ImagePath={slide.mobimgPath} ImageAlt={slide.imageAlt} ImageClass={'w-100 mobile-show'} ImageWidth={ImageWidth} ImageHeight={ImageHeight}/>
                </motion.div>
                <div className='col-lg-5 col-md-5 col-xs-12 col-12 bannerTextSlide'>
                  <AnimatedText text={slide.heading.replace(/<\/?[^>]+(>|$)/g, "")} />
                </div>
              </div>
            ))}
          </Swiperslider>
        )}
      </section>

    </>
  );
};

export default Index;
